import React from 'react';

import type { TPAComponentProps } from 'wix-ui-tpa/dist/cssVars/types/types';

import classes from './ListItemAvatar.scss';

interface IListItemAvatarProps extends TPAComponentProps {
  children: React.ReactNode;
}

export function ListItemAvatar(props: IListItemAvatarProps) {
  return <div className={classes.root}>{props.children}</div>;
}

ListItemAvatar.displayName = 'wui/ListItemAvatar';
